module.exports = __webpack_public_path__ + "static/media/Michael R. Zimmerman@2x.0aaa5a4f.jpg";